var _0xac0f = ["thefurnituregallery.com.au", "the-furniture-gallery-1.myshopify.com", "href", "location", "indexOf", "shopifypreview.com", "shopify.com", "script", "getElementsByTagName", "length", "data-src", "getAttribute", "src", "setAttribute", "dataset", "Kernel_Loading", "dispatchEvent", "lazyLoadScript", "scroll", "addEventListener", "mousemove", "touchstart", "load", "attachEvent", "onload"];
var domain_url = _0xac0f[0];
var domain_admin_url = _0xac0f[1];
var current_url = window[_0xac0f[3]][_0xac0f[2]];
if (current_url[_0xac0f[4]](domain_url) < 0 && current_url[_0xac0f[4]](domain_admin_url) < 0 && current_url[_0xac0f[4]](_0xac0f[5]) < 0 && current_url[_0xac0f[4]](_0xac0f[6])) {
} else {
var loadAsync = function lsnb_highlight() {
if (script_loaded) {
return;
} else {
script_loaded = true;
var PL$13 = document[_0xac0f[8]](_0xac0f[7]);
var PL$17 = 0;
for (; PL$17 < PL$13[_0xac0f[9]]; PL$17++) {
if (PL$13[PL$17][_0xac0f[11]](_0xac0f[10]) !== null) {
PL$13[PL$17][_0xac0f[13]](_0xac0f[12], PL$13[PL$17][_0xac0f[11]](_0xac0f[10]));
delete PL$13[PL$17][_0xac0f[14]][_0xac0f[12]];
}
}
document[_0xac0f[16]](new CustomEvent(_0xac0f[15]));
setTimeout(function() {
document[_0xac0f[16]](new CustomEvent(_0xac0f[17]));
}, 700);
}
};
var script_loaded = false;
window[_0xac0f[19]](_0xac0f[18], function(canCreateDiscussions) {
loadAsync();
});
window[_0xac0f[19]](_0xac0f[20], function() {
loadAsync();
});
window[_0xac0f[19]](_0xac0f[21], function() {
loadAsync();
});
if (window[_0xac0f[19]]) {
window[_0xac0f[19]](_0xac0f[22], function() {
setTimeout(loadAsync, 9000);
}, false);
} else {
if (window[_0xac0f[23]]) {
window[_0xac0f[23]](_0xac0f[24], function() {
setTimeout(loadAsync, 9000);
});
} else {
window[_0xac0f[24]] = loadAsync;
}}};